module.exports = __webpack_public_path__ + "img/logo.69d75f92.png";